export default __webpack_public_path__ + "static/media/info-the-law.e76e7ef8.jpg";